export const structure = [
  {
    label: "About",
    link: "/about",
  },
  {
    label: "Contact Us",
    link: "/contact-us",
  },
];
